(ns common.db.config
  (:require [re-frame.core :as rf]))

(defn get-config []
  (js->clj js/window.__LEMONPI_CONFIG__ :keywordize-keys true))

(defn config-available? []
  (some? (get-config)))

;; local | acceptance | production
(def env js/window.__LEMONPI_ENV__)

(defn production-env? [] (= "production" env))

(rf/reg-event-db :config/init
  (fn [db _]
    (if (seq (:config db))
      db
      (assoc db :config (get-config)))))

(rf/reg-sub :config
  (fn [db]
    (:config db)))
